export default __webpack_public_path__ + "static/media/cafeshow_own01.34a33220.png";